const React = require("react");
const { NavLink, Outlet } = require("react-router-dom");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { getCJDropshippingNavigation } = require("../navigation");
const { StatusBadge } = require("./ui");
const { CJ_DROPSHIPPING_CSS } = require("../styles");
const h = React.createElement;

const DropshippingLayout = () => {
  const { t, isFamily, isCJConnected } = useCJDropshipping();
  return h("div", { className: "cjds-shell" },
    h("style", null, CJ_DROPSHIPPING_CSS),
    h("header", { className: "cjds-top" },
      h("div", { className: "cjds-row" },
        h("h1", null, t("h_cj_title", "Dropshipping")),
        isCJConnected ? h(StatusBadge, { status: "active", t }) : null
      ),
      h("p", null, t("h_cj_subtitle", "Connect CJ, import products and manage supplier fulfillment."))
    ),
    h("nav", { className: "cjds-nav", "aria-label": t("h_cj_nav_label", "Dropshipping navigation") },
      ...getCJDropshippingNavigation(t, { isFamily, isCJConnected }).map((item) => h(
        NavLink,
        { key: item.to, to: item.to, className: ({ isActive }) => isActive ? "active" : "" },
        item.label
      ))
    ),
    h("main", { className: "cjds-main" }, h(Outlet))
  );
};

module.exports = { DropshippingLayout };
